<template>
  <div class="light-header">
    <button v-if="withBackButton" class="light-header__back-button" @click="$emit('back')">
      {{ $t('checkout.backToCart') }}
    </button>
    <img
      class="light-header__logo gte-960"
      src="@/assets/images/universkin-logo.svg"
      alt="Universkin"
    />
    <hr v-if="withBorderBottom" class="light-header__bottom-border" />
  </div>
</template>

<script>
export default {
  name: 'LightHeader',
  props: {
    withBackButton: {
      type: Boolean,
      default: false
    },
    withBorderBottom: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.light-header {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 65px;
  display: flex;
  align-items: center;

  background-color: white;
  z-index: 1000;
  --horizontal-padding: max(calc((100% - 600px) / 2), 16px);

  &__back-button {
    margin-left: var(--horizontal-padding);
    font-family: var(--u-font-family-Gilroy);
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0.75px;
    border: none;
    background-color: transparent;
    cursor: pointer;

    &::before {
      content: url(~@/assets/images/icons/icon-arrow.svg);
      margin-right: 13px;
    }
  }

  &__logo {
    width: 74px;
    height: 47px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &__bottom-border {
    position: absolute;
    bottom: 0;
    width: 100%;
    border: none;
    border-bottom: 1px solid var(--u-color-grey-200);
  }
}

@media (min-width: 960px) {
  .light-header {
    height: 100px;
    --horizontal-padding: 40px;
  }
}
</style>
